import { createSlice } from "@reduxjs/toolkit";

import { fetchTotalPipeline } from "./actions";

export const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const DEFAULT_ERROR = "Failed to load total pipeline";

const totalPipelineSlice = createSlice({
  name: "totalPipeline",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTotalPipeline.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTotalPipeline.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchTotalPipeline.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export default totalPipelineSlice.reducer;
